'use client'

export default function myImageLoader({ src }: { src: string; width: number; quality?: number }) {
    let origin = process.env.HA_BASE_URL || '';
    if (typeof window !== "undefined") {
        if (window.location?.origin)
            origin = window.location?.origin;
    };
    origin = origin?.replace(/\/+$/, ""); // Remove trailing slashes
    src = src.replace(/^\/+/, ""); // Remove leading slashes
    return `${origin}/${src}`;
}